export default __webpack_public_path__ + "static/Reykjavik-credit-CityofReykjavikUNESCOCityofLiterature-bfd9fba12b4e799df02c44c615bf57d0.jpg";